import { C } from '../../../lib/theme';
import { styles } from '../../../lib/styles';
import { fmtDateTime } from '../../../lib/util';
import type { Case } from '../../../domain/initial-cases';
import { resolveActorName } from '../../../auth/actorNames';
import { useAppData } from '../../../state/contexts/AppDataContext';

export function AuditTab({ c }: { c: Case }) {
  const { caseAudit } = useAppData();
  return (
    <div style={styles.card}>
      <h3 style={{ fontSize: 14, fontWeight: 600, marginBottom: 16 }}>Case Audit Trail</h3>
      <table style={styles.table}>
        <thead><tr><th style={styles.th}>Timestamp</th><th style={styles.th}>Actor</th><th style={styles.th}>Action</th><th style={styles.th}>Detail</th></tr></thead>
        <tbody>
          {[...(caseAudit[c.id] ?? [])].reverse().map((a, i) => (
            <tr key={i}>
              <td style={styles.td}><span style={{ fontSize: 11, fontFamily: 'monospace', color: C.textMuted }}>{fmtDateTime(a.timestamp)}</span></td>
              <td style={styles.td}>{resolveActorName(a)}</td>
              <td style={styles.td}><span style={{ ...styles.tag, background: C.goldBg, color: C.goldText, fontWeight: 600 }}>{a.action}</span></td>
              <td style={styles.td}>{typeof a.detail === 'string' ? a.detail : JSON.stringify(a.detail)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
